class ResponseError extends Error {
  constructor(title, detail, type, httpCode) {
    super(`${title}. ${detail}`);
    this.title = title;
    this.detail = detail;
    this.type = type;
    this.httpCode = httpCode;
  }
  getTypeCustomFields() {
    return {};
  }
  static ofDetailAndCode(detail, code) {
    return new ResponseError('', detail, '', code);
  }
}

module.exports = ResponseError;
